import CustomImage from '@/components/CustomImage';
import LanguageSwitcher from '@/components/LanguageSwitcher';
import { useFormatText } from '@/hooks/useFormatText';
import { useSettingsStore } from '@/store/useSettingsStore';
import { IChildren } from '@/types';

const AuthLayout = ({ children }: IChildren) => {
  const { settings } = useSettingsStore();
  const { formatText } = useFormatText();

  const isArabic = settings?.language === 'ar';
  const brandLogoSrc = isArabic
    ? '/assets/images/tirtir-world-ar.png'
    : '/assets/images/tirtir-world-en.png';

  return (
    <div className="flex h-screen w-screen" dir="ltr">
      <div
        className="relative w-[60%] m-6 max-md:hidden overflow-hidden rounded-2xl bg-cover bg-center"
        style={{
          backgroundImage: "url('/assets/images/admin-login.png')",
        }}
      >
        <CustomImage
          src={brandLogoSrc}
          alt={formatText('auth-layout.brand-alt')}
          className="absolute top-6 left-6 h-30 w-auto select-none pointer-events-none"
        />
        <span className="absolute top-6 right-6 inline-flex items-center rounded-[10px] bg-brand-default px-5 py-2 text-xl font-bold tracking-[-0.24px] text-white select-none">
          {formatText('auth-layout.admin-cta')}
        </span>
      </div>
      <div
        className="relative w-[40%] max-md:w-full overflow-y-auto min-h-screen flex flex-col justify-center items-center"
        dir={settings?.direction}
      >
        <div className="absolute top-6 end-6 z-50">
          <LanguageSwitcher />
        </div>
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
